import i18n from 'utils/i18n'
import type { AdminUsersFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  RADIO_LIST,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

export const getAdministrationUsersFiltersCollection = () => [
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.expertQualificationFilter),
    filterName:
      ADMIN_FILTERS_NAME.expertQualificationFilter satisfies AdminUsersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.expertQualificationFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.expertVerificationStatusFilter),
    filterName:
      ADMIN_FILTERS_NAME.expertVerificationStatusFilter satisfies AdminUsersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.expertVerificationStatusFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.userStatusFilter),
    filterName:
      ADMIN_FILTERS_NAME.userStatusFilter satisfies AdminUsersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.userStatusFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.permissionFilter),
    filterName:
      ADMIN_FILTERS_NAME.permissionFilter satisfies AdminUsersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.permissionFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(ADMIN_FILTERS_TITLE.createdAtFilter),
    filterName:
      ADMIN_FILTERS_NAME.createdAtFilter satisfies AdminUsersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.createdAtFilter,
  },
]

export const adminUsersFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationUsersFiltersCollection,
  pathToStore: [],
  filtersDataPath: ['admin', 'users', 'usersFilters'],
  showResultsTextKey: 'filters.button.apply',
  showPresets: false,
}
